import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {FormSelectItem} from '@common/form-components';

@Injectable()
export class ProvinciasService {
  provincias: Provincia[] = [
    {Pro_ID: 0, Pro_Provincia: 'CAPITAL FEDERAL'},
    {Pro_ID: 1, Pro_Provincia: 'BUENOS AIRES'},
    {Pro_ID: 2, Pro_Provincia: 'CATAMARCA'},
    {Pro_ID: 3, Pro_Provincia: 'CORDOBA'},
    {Pro_ID: 4, Pro_Provincia: 'CORRIENTES'},
    {Pro_ID: 5, Pro_Provincia: 'ENTRE RÍOS'},
    {Pro_ID: 6, Pro_Provincia: 'JUJUY'},
    {Pro_ID: 7, Pro_Provincia: 'MENDOZA'},
    {Pro_ID: 8, Pro_Provincia: 'LA RIOJA'},
    {Pro_ID: 9, Pro_Provincia: 'SALTA'},
    {Pro_ID: 10, Pro_Provincia: 'SAN JUAN'},
    {Pro_ID: 11, Pro_Provincia: 'SAN LUIS'},
    {Pro_ID: 12, Pro_Provincia: 'SANTA FE'},
    {Pro_ID: 13, Pro_Provincia: 'SANTIAGO DEL ESTERO'},
    {Pro_ID: 14, Pro_Provincia: 'TUCUMÁN'},
    {Pro_ID: 16, Pro_Provincia: 'CHACO'},
    {Pro_ID: 17, Pro_Provincia: 'CHUBUT'},
    {Pro_ID: 18, Pro_Provincia: 'FORMOSA'},
    {Pro_ID: 19, Pro_Provincia: 'MISIONES'},
    {Pro_ID: 20, Pro_Provincia: 'NEUQUÉN'},
    {Pro_ID: 21, Pro_Provincia: 'LA PAMPA'},
    {Pro_ID: 22, Pro_Provincia: 'RÍO NEGRO'},
    {Pro_ID: 23, Pro_Provincia: 'SANTA CRUZ'},
    {Pro_ID: 24, Pro_Provincia: 'TIERRA DEL FUEGO'},
  ];

  getProvinciasAsForm: FormSelectItem[];
  constructor() {
    this.getProvinciasAsForm = this.provincias.map(item => ({Id: item.Pro_ID, Label: item.Pro_Provincia, RawValue: JSON.stringify(item)}));
  }
  getProvincias() {
    return Observable.from([this.provincias])
  }

}
export interface Provincia {Pro_ID: number, Pro_Provincia: string}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/provincias-service.ts